import type {MediaAsset} from '../types';
import {apiRequest} from '../api/client';
import {getLocalAsset} from './media-download';
export async function ensureServerReference(media:MediaAsset,userId:string,temporary=true):Promise<MediaAsset>{
  if(!media.stored_on_device)return media;
  if(media.server_deletion_pending)return {...media,stored_on_device:false};
  const stored=await getLocalAsset(userId,media.id);
  if(!stored)throw new Error('Файл больше не доступен из приложения. Добавьте его заново с телефона.');
  const body=new FormData();body.append('file',stored.blob,media.original_name||`vgen-${media.id}`);
  const result=await apiRequest<{media:{id:string;kind:MediaAsset['kind'];originalName:string;byteSize:number}}>(`/api/media${temporary?'?temporary=true':''}`,{method:'POST',body});
  return {...media,id:result.media.id,kind:result.media.kind,stored_on_device:false,temporary};
}
